import { render } from "./VoteModal.vue?vue&type=template&id=54005fe2&scoped=true"
import script from "./VoteModal.vue?vue&type=script&lang=js"
export * from "./VoteModal.vue?vue&type=script&lang=js"

import "./VoteModal.vue?vue&type=style&index=0&id=54005fe2&scoped=true&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54005fe2"]])

export default __exports__